// extracted by mini-css-extract-plugin
module.exports = {"btn":"GoBackToTop_btn__3VvGm","arrows":"GoBackToTop_arrows___fAh4","show":"GoBackToTop_show__1j74-","fadeIn":"GoBackToTop_fadeIn__1JB3w","fadeOut":"GoBackToTop_fadeOut__YZQjS"};